/**
 * Static configuration for the Language Selector component
 * @fileoverview Contains all static configuration data for language options
 */

import { FranceIcon, ItalyIcon, UKIcon, USAIcon } from '../../../icons';

import { type LabelDict, type LanguageData } from './LanguageSelector.types';

/**
 * Default language labels
 */
export const DEFAULT_LABEL_DICT: LabelDict = {
  'en-US': 'English (US)',
  en: 'English',
  it: 'Italian',
  fr: 'French',
} as const;

/**
 * Default error message for language loading failures
 */
export const DEFAULT_ERROR_TEXT =
  'Something went wrong loading your selected language';

/**
 * Creates language data array from label dictionary
 * @param labelDict - Dictionary of language labels
 * @returns Array of language data with icons and metadata
 */
export const createLanguageData = (labelDict: LabelDict): LanguageData[] => [
  {
    language: 'en-US',
    icon: USAIcon,
    label: labelDict['en-US'],
    alt: 'US flag',
  },
  {
    language: 'en',
    icon: UKIcon,
    label: labelDict['en'],
    alt: 'GB flag',
  },
  {
    language: 'fr',
    icon: FranceIcon,
    label: labelDict['fr'],
    alt: 'FR flag',
  },
  {
    language: 'it',
    icon: ItalyIcon,
    label: labelDict['it'],
    alt: 'IT flag',
  },
];
